"use strict";
var __assign =
  (this && this.__assign) ||
  function () {
    __assign =
      Object.assign ||
      function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
      };
    return __assign.apply(this, arguments);
  };
var __awaiter =
  (this && this.__awaiter) ||
  function (thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P
        ? value
        : new P(function (resolve) {
            resolve(value);
          });
    }
    return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e) {
          reject(e);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e) {
          reject(e);
        }
      }
      function step(result) {
        result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
var __generator =
  (this && this.__generator) ||
  function (thisArg, body) {
    var _ = {
        label: 0,
        sent: function () {
          if (t[0] & 1) throw t[1];
          return t[1];
        },
        trys: [],
        ops: [],
      },
      f,
      y,
      t,
      g;
    return (
      (g = { next: verb(0), throw: verb(1), return: verb(2) }),
      typeof Symbol === "function" &&
        (g[Symbol.iterator] = function () {
          return this;
        }),
      g
    );
    function verb(n) {
      return function (v) {
        return step([n, v]);
      };
    }
    function step(op) {
      if (f) throw new TypeError("Generator is already executing.");
      while (_)
        try {
          if (
            ((f = 1),
            y &&
              (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) &&
              !(t = t.call(y, op[1])).done)
          )
            return t;
          if (((y = 0), t)) op = [op[0] & 2, t.value];
          switch (op[0]) {
            case 0:
            case 1:
              t = op;
              break;
            case 4:
              _.label++;
              return { value: op[1], done: false };
            case 5:
              _.label++;
              y = op[1];
              op = [0];
              continue;
            case 7:
              op = _.ops.pop();
              _.trys.pop();
              continue;
            default:
              if (!((t = _.trys), (t = t.length > 0 && t[t.length - 1])) && (op[0] === 6 || op[0] === 2)) {
                _ = 0;
                continue;
              }
              if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                _.label = op[1];
                break;
              }
              if (op[0] === 6 && _.label < t[1]) {
                _.label = t[1];
                t = op;
                break;
              }
              if (t && _.label < t[2]) {
                _.label = t[2];
                _.ops.push(op);
                break;
              }
              if (t[2]) _.ops.pop();
              _.trys.pop();
              continue;
          }
          op = body.call(thisArg, _);
        } catch (e) {
          op = [6, e];
          y = 0;
        } finally {
          f = t = 0;
        }
      if (op[0] & 5) throw op[1];
      return { value: op[0] ? op[1] : void 0, done: true };
    }
  };
var __spreadArrays =
  (this && this.__spreadArrays) ||
  function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
      for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];
    return r;
  };
var __importDefault =
  (this && this.__importDefault) ||
  function (mod) {
    return mod && mod.__esModule ? mod : { default: mod };
  };
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.setLogOutput = exports.setLogConfig = exports.consoleLog = void 0;
var flatted_1 = require("flatted");
var consoleRe_1 = require("./consoleRe");
var logOverlay_1 = __importDefault(require("./logOverlay"));
var menu_1 = require("./menu");
var remoteJS_1 = require("./remoteJS");
var sentry_1 = require("./sentry");
var types_1 = require("./types");
var consoleTrace = console.trace.bind(console);
var consoleDebug = console.debug.bind(console);
exports.consoleLog = console.log.bind(console);
var consoleInfo = console.info.bind(console);
var consoleWarn = console.warn.bind(console);
var consoleError = console.error.bind(console);
// in order to prevent crashing when logging too early to console.re
console.re = console;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
window._LogContext = {
  namespacedLog: {},
  logConfig: {
    lightUI: false,
    menuTriggerSequences: [],
    overlayFontSize: 16,
    namespaces: [],
    levels: {},
    remotePrefix: "dotscreen",
    initialLogOutput: "console",
  },
  logOutput: undefined,
  logMenu: undefined,
};
function setLogConfig(config) {
  if (
    config.remapConsoleToNamespace &&
    _LogContext.logConfig.remapConsoleToNamespace &&
    config.remapConsoleToNamespace != _LogContext.logConfig.remapConsoleToNamespace
  ) {
    consoleError(
      "remapping console output to " +
        config.remapConsoleToNamespace +
        " when it was already mapped to " +
        _LogContext.logConfig.remapConsoleToNamespace
    );
  }
  _LogContext.logConfig = __assign(__assign({}, _LogContext.logConfig), config);
}
exports.setLogConfig = setLogConfig;
/**
 * Used to change console that hosting log
 * @param inputLogOutput choose where you want to display your logs
 */
exports.setLogOutput = function (inputLogOutput, inputCode) {
  var _a, _b, _c, _d;
  if (inputCode === void 0) {
    inputCode = "0000";
  }
  _LogContext.logMenu = (_a = _LogContext.logMenu) !== null && _a !== void 0 ? _a : new menu_1.LogMenu();
  // localStorage overrides rules:
  // If no logOutput provided, then defaults to last output, or console (use case: only a library initialized a log)
  // If output is provided, it means it's an app that has instanciated the log, and therefore we want to take the localStorage in account
  var logOutput = inputLogOutput
    ? (_b = localStorage.getItem("logOutput")) !== null && _b !== void 0
      ? _b
      : inputLogOutput
    : (_c = window._LogContext.logOutput) !== null && _c !== void 0
    ? _c
    : "console";
  var code = (_d = localStorage.getItem("remoteCode")) !== null && _d !== void 0 ? _d : inputCode;
  var resetNameSpaces = function (newLogOutput) {
    window._LogContext.logOutput = newLogOutput;
    var allNamespaces = Array.from(
      new Set(__spreadArrays(Object.keys(window._LogContext.namespacedLog), _LogContext.logConfig.namespaces))
    );
    if (
      _LogContext.logConfig.remapConsoleToNamespace &&
      !allNamespaces.includes(_LogContext.logConfig.remapConsoleToNamespace)
    )
      allNamespaces.push(_LogContext.logConfig.remapConsoleToNamespace);
    console.log("resetNameSpaces", JSON.stringify(allNamespaces));
    allNamespaces.forEach(function (namespace) {
      window._LogContext.namespacedLog[namespace] = createNamespace(newLogOutput, namespace);
    });
    switch (newLogOutput) {
      case "consoleRe": // prevent stack overflow as console.re does use console logs also
        console.trace = consoleTrace;
        console.debug = consoleDebug;
        console.log = exports.consoleLog;
        console.info = consoleInfo;
        console.warn = consoleWarn;
        console.error = consoleError;
        break;
      case "remoteJS":
        // console logs have been overriden already by remoteJS, don't change
        break;
      default:
        if (_LogContext.logConfig.remapConsoleToNamespace) {
          console.trace = window._LogContext.namespacedLog[_LogContext.logConfig.remapConsoleToNamespace].trace;
          console.debug = window._LogContext.namespacedLog[_LogContext.logConfig.remapConsoleToNamespace].debug;
          console.log = window._LogContext.namespacedLog[_LogContext.logConfig.remapConsoleToNamespace].log;
          console.info = window._LogContext.namespacedLog[_LogContext.logConfig.remapConsoleToNamespace].info;
          console.warn = window._LogContext.namespacedLog[_LogContext.logConfig.remapConsoleToNamespace].warn;
          console.error = window._LogContext.namespacedLog[_LogContext.logConfig.remapConsoleToNamespace].error;
        } else {
          console.trace = consoleTrace;
          console.debug = consoleDebug;
          console.log = exports.consoleLog;
          console.info = consoleInfo;
          console.warn = consoleWarn;
          console.error = consoleError;
        }
        break;
    }
  };
  switch (_LogContext.logOutput) {
    case "overlay":
      logOverlay_1.default.hide();
      break;
    case "consoleRe":
      consoleRe_1.detachConsoleRe();
      break;
    case "remoteJS":
      remoteJS_1.detachremoteJS();
      break;
  }
  switch (logOutput) {
    case "sentry":
    case "console":
      resetNameSpaces(logOutput);
      break;
    case "overlay":
      logOverlay_1.default.show();
      resetNameSpaces(logOutput);
      break;
    case "consoleRe":
      // default to console at the beginning for remote logging - as it takes time
      resetNameSpaces("console");
      (function () {
        return __awaiter(void 0, void 0, void 0, function () {
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                console.warn("will attach consoleRe");
                return [4 /*yield*/, consoleRe_1.attachConsoleRe(code)];
              case 1:
                _a.sent();
                console.warn("did attach consoleRe");
                // things have changed, reset the Log object!
                resetNameSpaces("consoleRe");
                return [2 /*return*/];
            }
          });
        });
      })();
      break;
    case "remoteJS":
      // default to console at the beginning for remote logging - as it takes time
      resetNameSpaces("console");
      (function () {
        return __awaiter(void 0, void 0, void 0, function () {
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                console.warn("will attach remoteJS");
                return [4 /*yield*/, remoteJS_1.attachremoteJS(code)];
              case 1:
                _a.sent();
                console.warn("did attach remoteJS");
                // things have changed, reset the Log object!
                resetNameSpaces("remoteJS");
                return [2 /*return*/];
            }
          });
        });
      })();
      break;
  }
  if (inputLogOutput && localStorage.getItem("logOutput")) {
    window._LogContext.namespacedLog._.warn("Log output has been overriden from localStorage.logOutput");
    window._LogContext.namespacedLog._.warn(inputLogOutput + " => " + localStorage.getItem("logOutput"));
  }
  return window._LogContext.namespacedLog;
};
var logLevelToString =
  ((_a = {}),
  (_a[types_1.LogLevel.error] = "E"),
  (_a[types_1.LogLevel.warn] = "W "),
  (_a[types_1.LogLevel.info] = "I"),
  (_a[types_1.LogLevel.debug] = "d"),
  (_a[types_1.LogLevel.trace] = "t"),
  _a);
var first = Date.now();
function elapsed() {
  var duration = Date.now() - first;
  var hundredth = Math.floor((duration % 1000) / 10),
    seconds = Math.floor((duration / 1000) % 60),
    minutes = Math.floor((duration / (1000 * 60)) % 60),
    hours = Math.floor((duration / (1000 * 60 * 60)) % 24);
  return (
    (hours < 10 ? "0" + hours : "" + hours) +
    ":" +
    (minutes < 10 ? "0" + minutes : "" + minutes) +
    ":" +
    (seconds < 10 ? "0" + seconds : "" + seconds) +
    "." +
    (hundredth < 10 ? "0" + hundredth : "" + hundredth)
  );
}
var _noop = function () {};
function sentryLog(level) {
  var data = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    data[_i - 1] = arguments[_i];
  }
  // not interested in some specific reduxLogger messages
  if (data && data.length && data[0] === "—— log end ——") return;
  if (level != types_1.LogLevel.off) {
    // always log errors
    var output = data
      .map(function (obj) {
        switch (typeof obj) {
          case "object":
          case "function":
            return flatted_1.stringify(obj, null, 2).substring(0, 2048);
          case "undefined":
            return "undefined";
          default:
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return obj.toString();
        }
      })
      .join(" ");
    // only do some cleanup when reaching +10%
    if (sentry_1.sentryLogBuffer.length > Math.floor(sentry_1.MAX_SENTRY_LOGS * 1.1)) {
      // consoleWarn("clearing space", sentryLogBuffer.length);
      sentry_1.sentryLogBuffer.splice(0, Math.floor(sentry_1.MAX_SENTRY_LOGS * 0.1) + 1);
      // consoleWarn("cleared space", sentryLogBuffer.length);
    }
    // elapsed();
    sentry_1.sentryLogBuffer.push({ timestamp: elapsed(), log: logLevelToString[level] + " " + output });
  }
}
function overlayLog(level) {
  var data = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    data[_i - 1] = arguments[_i];
  }
  sentryLog.apply(void 0, __spreadArrays([level], data));
  logOverlay_1.default.logWithLevel(level, sentry_1.sentryLogBuffer[sentry_1.sentryLogBuffer.length - 1]);
}
var createNamespace = function (logOutput, namespace) {
  var _a;
  var NAMESPACE = namespace.toUpperCase();
  var level = (_a = _LogContext.logConfig.levels[namespace]) !== null && _a !== void 0 ? _a : 3;
  switch (logOutput) {
    case "console":
      return {
        trace: level >= types_1.LogLevel.trace ? consoleTrace.bind(console, "[" + NAMESPACE + "]") : _noop,
        debug: level >= types_1.LogLevel.debug ? consoleDebug.bind(console, "[" + NAMESPACE + "]") : _noop,
        // log <-> info
        log: level >= types_1.LogLevel.info ? exports.consoleLog.bind(console, "[" + NAMESPACE + "]") : _noop,
        info: level >= types_1.LogLevel.info ? consoleInfo.bind(console, "[" + NAMESPACE + "]") : _noop,
        warn: level >= types_1.LogLevel.warn ? consoleWarn.bind(console, "[" + NAMESPACE + "]") : _noop,
        error: level >= types_1.LogLevel.error ? consoleError.bind(console, "[" + NAMESPACE + "]") : _noop,
      };
    case "remoteJS":
      if (console.log == exports.consoleLog) {
        return createNamespace("console", namespace);
      } else {
        return {
          trace: function () {
            var data = [];
            for (var _i = 0; _i < arguments.length; _i++) {
              data[_i] = arguments[_i];
            }
            return level >= types_1.LogLevel.trace
              ? console.trace.apply(console, __spreadArrays(["[" + NAMESPACE + "]"], data))
              : _noop;
          },
          debug: function () {
            var data = [];
            for (var _i = 0; _i < arguments.length; _i++) {
              data[_i] = arguments[_i];
            }
            return level >= types_1.LogLevel.debug
              ? console.debug.apply(console, __spreadArrays(["[" + NAMESPACE + "]"], data))
              : _noop;
          },
          // log <-> info
          log: function () {
            var data = [];
            for (var _i = 0; _i < arguments.length; _i++) {
              data[_i] = arguments[_i];
            }
            return level >= types_1.LogLevel.info
              ? console.info.apply(console, __spreadArrays(["[" + NAMESPACE + "]"], data))
              : _noop;
          },
          info: function () {
            var data = [];
            for (var _i = 0; _i < arguments.length; _i++) {
              data[_i] = arguments[_i];
            }
            return level >= types_1.LogLevel.info
              ? console.info.apply(console, __spreadArrays(["[" + NAMESPACE + "]"], data))
              : _noop;
          },
          warn: function () {
            var data = [];
            for (var _i = 0; _i < arguments.length; _i++) {
              data[_i] = arguments[_i];
            }
            return level >= types_1.LogLevel.warn
              ? console.warn.apply(console, __spreadArrays(["[" + NAMESPACE + "]"], data))
              : _noop;
          },
          error: function () {
            var data = [];
            for (var _i = 0; _i < arguments.length; _i++) {
              data[_i] = arguments[_i];
            }
            return level >= types_1.LogLevel.error
              ? console.error.apply(console, __spreadArrays(["[" + NAMESPACE + "]"], data))
              : _noop;
          },
        };
      }
    case "consoleRe":
      //we know console.re is defined if __CONSOLE_RE_CHANNEL__ is defined as it's been waited for in main.ts
      return {
        trace: level >= types_1.LogLevel.trace ? console.re.trace.bind(console.re.trace, "[" + NAMESPACE + "]") : _noop,
        debug: level >= types_1.LogLevel.debug ? console.re.debug.bind(console.re.debug, "[" + NAMESPACE + "]") : _noop,
        // log <-> info
        log: level >= types_1.LogLevel.info ? console.re.info.bind(console.re.info, "[" + NAMESPACE + "]") : _noop,
        info: level >= types_1.LogLevel.info ? console.re.info.bind(console.re.info, "[" + NAMESPACE + "]") : _noop,
        warn: level >= types_1.LogLevel.warn ? console.re.warn.bind(console.re.warn, "[" + NAMESPACE + "]") : _noop,
        error: level >= types_1.LogLevel.error ? console.re.error.bind(console.re.error, "[" + NAMESPACE + "]") : _noop,
      };
    case "sentry":
      return {
        trace: function () {
          var data = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            data[_i] = arguments[_i];
          }
          return level >= types_1.LogLevel.trace
            ? sentryLog.apply(void 0, __spreadArrays([types_1.LogLevel.trace, "[" + NAMESPACE + "]"], data))
            : _noop;
        },
        debug: function () {
          var data = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            data[_i] = arguments[_i];
          }
          return level >= types_1.LogLevel.debug
            ? sentryLog.apply(void 0, __spreadArrays([types_1.LogLevel.debug, "[" + NAMESPACE + "]"], data))
            : _noop;
        },
        // log <-> info
        log: function () {
          var data = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            data[_i] = arguments[_i];
          }
          return level >= types_1.LogLevel.info
            ? sentryLog.apply(void 0, __spreadArrays([types_1.LogLevel.info, "[" + NAMESPACE + "]"], data))
            : _noop;
        },
        info: function () {
          var data = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            data[_i] = arguments[_i];
          }
          return level >= types_1.LogLevel.info
            ? sentryLog.apply(void 0, __spreadArrays([types_1.LogLevel.info, "[" + NAMESPACE + "]"], data))
            : _noop;
        },
        warn: function () {
          var data = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            data[_i] = arguments[_i];
          }
          return level >= types_1.LogLevel.warn
            ? sentryLog.apply(void 0, __spreadArrays([types_1.LogLevel.warn, "[" + NAMESPACE + "]"], data))
            : _noop;
        },
        error: function () {
          var data = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            data[_i] = arguments[_i];
          }
          return level >= types_1.LogLevel.error
            ? sentryLog.apply(void 0, __spreadArrays([types_1.LogLevel.error, "[" + NAMESPACE + "]"], data))
            : _noop;
        },
      };
    case "overlay":
      return {
        trace: function () {
          var data = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            data[_i] = arguments[_i];
          }
          return level >= types_1.LogLevel.trace
            ? overlayLog.apply(void 0, __spreadArrays([types_1.LogLevel.trace, "[" + NAMESPACE + "]"], data))
            : _noop;
        },
        debug: function () {
          var data = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            data[_i] = arguments[_i];
          }
          return level >= types_1.LogLevel.debug
            ? overlayLog.apply(void 0, __spreadArrays([types_1.LogLevel.debug, "[" + NAMESPACE + "]"], data))
            : _noop;
        },
        // log <-> info
        log: function () {
          var data = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            data[_i] = arguments[_i];
          }
          return level >= types_1.LogLevel.info
            ? overlayLog.apply(void 0, __spreadArrays([types_1.LogLevel.info, "[" + NAMESPACE + "]"], data))
            : _noop;
        },
        info: function () {
          var data = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            data[_i] = arguments[_i];
          }
          return level >= types_1.LogLevel.info
            ? overlayLog.apply(void 0, __spreadArrays([types_1.LogLevel.info, "[" + NAMESPACE + "]"], data))
            : _noop;
        },
        warn: function () {
          var data = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            data[_i] = arguments[_i];
          }
          return level >= types_1.LogLevel.warn
            ? overlayLog.apply(void 0, __spreadArrays([types_1.LogLevel.warn, "[" + NAMESPACE + "]"], data))
            : _noop;
        },
        error: function () {
          var data = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            data[_i] = arguments[_i];
          }
          return level >= types_1.LogLevel.error
            ? overlayLog.apply(void 0, __spreadArrays([types_1.LogLevel.error, "[" + NAMESPACE + "]"], data))
            : _noop;
        },
      };
  }
};
//# sourceMappingURL=global.js.map
